import Vue from 'vue';
import Vuex from 'vuex';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import vuetify from './plugins/vuetify';
import router from './router';

import App from './App.vue';

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

import { store } from './store.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faAmbulance,
	faBars,
	faBolt,
	faCalendarAlt,
	faCarSide,
	faClock,
	faDoorOpen,
	faHeadSideMask,
	faHistory,
	faHotel,
	faHomeLgAlt,
	faIdBadge,
	faInboxIn,
	faLifeRing,
	faLuggageCart,
	faMapMarked,
	faMapMarkedAlt,
	faNewspaper,
	faPodium,
	faPassport,
	faPlane,
	faReceipt,
	faSquare,
	faSunCloud,
	faUmbrellaBeach,
	faUsdCircle,
	faUserCircle,
	faUsers,
	faAward,
	faFile,
	faBus,
	faMoneyCheck
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
	faAmbulance,
	faAward,
	faBars,
	faBolt,
	faCalendarAlt,
	faCarSide,
	faClock,
	faDoorOpen,
	faFile,
	faHeadSideMask,
	faHistory,
	faHotel,
	faHomeLgAlt,
	faIdBadge,
	faInboxIn,
	faLifeRing,
	faLuggageCart,
	faMapMarked,
	faMapMarkedAlt,
	faNewspaper,
	faPodium,
	faPassport,
	faPlane,
	faReceipt,
	faSquare,
	faSunCloud,
	faUmbrellaBeach,
	faUsdCircle,
	faUserCircle,
	faMoneyCheck,
	faBus,
	faUsers
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(Vuex);

require('dotenv').config();

var firebaseConfig = {
	apiKey: 'AIzaSyBzvV3NMspoONngf5AkwegdrxxNUHjc1uQ',
	authDomain: 'icbem2020-c618e.firebaseapp.com',
	databaseURL: 'https://icbem2020-c618e.firebaseio.com',
	projectId: 'icbem2020-c618e',
	storageBucket: 'icbem2020-c618e.appspot.com',
	messagingSenderId: '174664097177',
	appId: '1:174664097177:web:0c9c2da3a8c98f28'
};

firebase.initializeApp(firebaseConfig);

// Use Firebase emulator for local testing
var db = firebase.database();
var auth = firebase.auth();
var func = firebase.functions();
if (location.hostname === 'localhost') {
	db.useEmulator('localhost', 9001);
	auth.useEmulator('http://localhost:9099/');
	func.useEmulator('localhost', 9000);
}

firebase
	.auth()
	.setPersistence(firebase.auth.Auth.Persistence.SESSION)
	.then(function() {});

firebase.auth().onAuthStateChanged(user => {
	store.dispatch('fetchUser', user);
	if (user) {
		user.getIdTokenResult().then(idTokenResult => {
			if (idTokenResult.claims['admin']) {
				store.dispatch('setAdmin', true);
			} else {
				store.dispatch('setAdmin', false);
			}
		});
	}
});

Vue.filter('currency', value => {
	if (typeof value !== 'number') {
		return value;
	}
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2
	});
	return formatter.format(value);
});

Sentry.init({
	Vue: Vue,
	dsn:
		'https://795f1a81dd4d4dc7999bdb8344c1f3da@o495347.ingest.sentry.io/5575689',
	logErrors: true,
	autoSessionTracking: true,
	integrations: [new Integrations.BrowserTracing()],
	tracesSampleRate: 1.0,
	environment: process.env.VUE_APP_FIREBASE_LOGGER_ENVIRONMENT
});

new Vue({
	vuetify,
	store,
	router,
	render: h => h(App)
}).$mount('#app');
